import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ArrowRight, Rocket, Users } from 'lucide-react'

export const DemoAccess = () => {
  const navigate = useNavigate()

  const startDemo = () => {
    // Set mock mode and demo mode
    localStorage.setItem('mockMode', 'true')
    localStorage.setItem('demoMode', 'true')
    
    // Create a demo session
    const demoUser = {
      id: 'demo-user-001',
      email: 'demo@frauddetection.com',
      full_name: 'Demo User',
      organization: 'Demo Company',
      role: 'admin',
      isDemo: true
    }
    
    localStorage.setItem('demoUser', JSON.stringify(demoUser))
    localStorage.setItem('isAuthenticated', 'demo')
    
    // Navigate directly to dashboard
    window.location.href = '/dashboard'
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="relative overflow-hidden"
    >
      <div className="bg-gradient-to-br from-primary to-secondary rounded-2xl p-8 md:p-12 text-white relative">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-4 right-4 w-32 h-32 rounded-full bg-white/20"></div>
          <div className="absolute bottom-4 left-4 w-24 h-24 rounded-full bg-white/10"></div>
          <div className="absolute top-1/2 left-1/2 w-40 h-40 rounded-full bg-white/5 transform -translate-x-1/2 -translate-y-1/2"></div>
        </div>

        <div className="relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="text-center md:text-left"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              See It In Action - No Setup Required
            </h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl">
              Experience our fraud detection platform with realistic demo data. 
              Explore real-time detection, pattern analysis, and financial impact tracking instantly.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-8">
              <Button 
                onClick={startDemo}
                size="lg"
                variant="secondary"
                className="bg-white text-primary hover:bg-white/90 text-lg px-8 py-4 h-auto group"
              >
                <Rocket className="mr-2 h-5 w-5 group-hover:animate-pulse" />
                Try Live Demo
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              
              <Button 
                onClick={() => navigate('/auth/request-access')}
                size="lg"
                variant="outline"
                className="border-white/30 text-white hover:bg-white/10 text-lg px-8 py-4 h-auto"
              >
                <Users className="mr-2 h-5 w-5" />
                Join Private Beta
              </Button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm opacity-75">
              <div className="flex items-center">
                <span className="w-2 h-2 bg-white rounded-full mr-2"></span>
                500+ Sample Leads
              </div>
              <div className="flex items-center">
                <span className="w-2 h-2 bg-white rounded-full mr-2"></span>
                Real-time Alerts
              </div>
              <div className="flex items-center">
                <span className="w-2 h-2 bg-white rounded-full mr-2"></span>
                All Features Enabled
              </div>
              <div className="flex items-center">
                <span className="w-2 h-2 bg-white rounded-full mr-2"></span>
                No Registration
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  )
}
